import { Stack } from "@mui/material";
import { MoneyFormatv3 } from "../../../library/MoneyFormat";
import { formatNumber } from "../../../utils/common";
import { memo, useMemo } from "react";
import { cellStyle } from "../styles";
import { useSelector } from "react-redux";
import { billingCurrencyOptions } from "../../../utils/Data/StaticData";

export const TransactionSummary = memo(({ data, matches }) => {
    const details = useMemo(() => ({
        totalDebit: MoneyFormatv3(data.totalDebit),
        totalCredit: MoneyFormatv3(data.totalCredit),
        closingBalance: formatNumber(Number(data.closingBalance), true, true, data.balanceSign),
        balanceSign: data?.balanceSign || 0,
    }), [data.totalDebit, data.totalCredit, data.closingBalance, data.balanceSign]);

    const currencycd = useSelector((state) => state.companyReducer?.companyDetails?.relatedcompanydetailsnew?.[0]?.currencycd);
    
    const currency = useMemo(() => 
        billingCurrencyOptions.find((item) => Number(item.value) === (currencycd || 1))
    , [currencycd]);

    const fontSize = matches ? "13px" : "";
    const currencySign = currency?.sign ?? '';

    return (
        <Stack direction="row" spacing={3} alignItems="center" sx={cellStyle}>
            <p fontSize="small" fontWeight="bold" style={{fontSize}}>
                Total Dr: {currencySign}{" "}{details.totalDebit}{" "}
            </p>
            <p fontSize="small" fontWeight="bold" style={{fontSize}}>
                Total Cr: {currencySign}{" "}{details.totalCredit}{" "}
            </p>
            <p fontSize="small" fontWeight="bold" style={{fontSize}}>
                Cl Bal: {currencySign}{" "}{details.closingBalance}
            </p>
        </Stack>
    );
});
TransactionSummary.displayName = "TransactionSummary";